import React from "react";

// 1. Add FontAwesome CDN to your index.html if not already there:
// <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />

const FEEDBACKS = [
  {
  id: 1,
  name: "Sai & Priya",
  role: "Vijayawada",
  text: "We ordered a hoop embroidery piece as a memory of our wedding, and it turned out beautifully. The detailing is so elegant and emotional — something we’ll treasure forever!",
  rating: 5,
  color: "#A4B494", // Sage Green
},
  {
  id: 2,
  name: "Prasanna",
  role: "Hyderabad",
  text: "I ordered a custom embroidered keychain for my scooty and it is so cute! The quality feels premium and the detailing is perfect. I absolutely love it!",
  rating: 5,
  color: "#D1B284", // Gold
},

  {
  id: 3,
  name: "Karthik & Ananya",
  role: "Vizag",
  text: "We ordered a photo embroidery piece as a memory of our vacation. The detailing brought our moment to life. It is a heartfelt keepsake.",
  rating: 5,
  color: "#8D7B68", // Earthy Brown
},
 {
  id: 4,
  name: "Sravani",
  role: "Warangal",
  text: "I ordered an embroidered frock for my daughter, and it turned out absolutely beautiful. The stitching, colors, and finishing were perfect—she loved it!",
  rating: 5,
  color: "#A4B494", // Sage Green
},
 {
  id: 5,
  name: "Thanushree",
  role: "Bhimavaram",
  text: "I ordered an embroidered accessory for my AirPods, and it is so cute and perfectly made. The detailing is neat and the finish feels premium—absolutely loved it!",
  rating: 5,
  color: "#A4B494", // Sage Green
},
];


// Duplicate the array to create the seamless infinite loop effect
const MARQUEE_ITEMS = [...FEEDBACKS, ...FEEDBACKS];

export default function Testimonials() {
  return (
    <section className="testi-section">
      <div className="testi-header">
        <h2 className="testi-title">
          Our <span className="highlight">Client</span> Feedback 
        </h2>
        <p className="testi-sub">Kind words from our cherished community</p>
      </div>

      <div className="testi-marquee-wrapper">
        <div className="testi-track">
          {MARQUEE_ITEMS.map((item, index) => (
            <div className="testi-card" key={index}>
              {/* Floating Quote Icon Badge */}
              <div 
                className="quote-badge" 
                style={{ backgroundColor: item.color }}
              >
                <i className="fa-solid fa-quote-left"></i>
              </div>

              {/* Card Content */}
              <div className="card-content">
                <h3 className="client-name">{item.name}</h3>
                <span className="client-role">{item.role}</span>
                
                <div className="star-rating">
                  {[...Array(item.rating)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star"></i>
                  ))}
                </div>

                <p className="client-text">
                  "{item.text}"
                </p>
              </div>

              {/* Watermark Icon at bottom right */}
              <i className="fa-solid fa-quote-right watermark-icon"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}